import axios from "axios";

const api = axios.create({
  baseURL: "/",
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  try {
    const auth = localStorage.getItem("authToken");
    const token = auth ? JSON.parse(auth).accessToken : null;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    localStorage.removeItem("authToken");
  }

  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response?.status === 401) {
      const auth = localStorage.getItem("authToken");
      const refreshToken = auth ? JSON.parse(auth).refreshToken : null;

      if (!refreshToken) {
        localStorage.clear();
        window.location.href = "/admin/login";
        return;
      }

      try {
        const res = await api.post("/auth/refresh", { refreshToken });

        const newAuth = {
          accessToken: res.data.accessToken,
          refreshToken: res.data.refreshToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuth));

        error.config.headers.Authorization = `Bearer ${res.data.accessToken}`;
        return api(error.config);
      } catch {
        localStorage.removeItem("authToken");
        window.location.href = "/admin/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;

